import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getEventLogs: async (options = {}) => {
    const {
      start,
      end,
      finds = {},
      orders = {},
      params = {},
    } = options;

    if (!start || !end) {
      throw new Error('start and end timestamps are required');
    }

    if (Number(end) <= Number(start)) {
      throw new Error('The "end" timestamp must be greater than "start" timestamp.');
    }

    const baseUrl = `/log/event/event/period/${start}/${end}`;

    let findsParams = '';
    Object.entries(finds).forEach(([key, value], index, array) => {
      const isLast = index === array.length - 1;
      if (value === '' || value === null) return;
      findsParams += `finds[${key}]=${value}${isLast ? '' : '&'}`;
    });

    let ordersParams = '';
    Object.entries(orders).forEach(([key, value], index, array) => {
      const isLast = index === array.length - 1;
      if (value === '' || value === null) return;
      ordersParams += `orders[${key}]=${value}${isLast ? '' : '&'}`;
    });

    let otherParams = '';
    Object.entries(params).forEach(([key, value], index, array) => {
      const isLast = index === array.length - 1;
      if (value === '' || value === null) return;
      otherParams += `${key}=${value}${isLast ? '' : '&'}`;
    });

    try {
      const response = await axiosInstance.get(`${baseUrl}?${findsParams}&${ordersParams}&${otherParams}`, {
        cancelToken: getNewCancelToken(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching log event:', error);
      throw error;
    }
  },
};
